


























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';

import { StoreModel, ShipmentProvider, FedEx } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import {storeService} from '@/shared';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class ShipmentProviderPage extends Base {
  public storeViewModel: any = {};
  public storeModel: StoreModel = {};
  public shipmentProviderModel: ShipmentProvider = {};
  public shipmentFedExModel: FedEx = {};
  public form: any = {};
  public storeShipmentProviderFields: Array<VFields<any>> = [];
  public storeId: number = 0;

  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public requestProgress: boolean = false;

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'Shipment' },
        })
        .catch((ex) => {console.log(ex);});
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(
          false,
          this.$t('stores.shipmentProviders.alertInvalidForm')
        );
        this.resetMethodName(methodName);
        return;
      }
      this.saveStoreShipmentProvider();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.setShipmentProviderFields();
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
      this.getStoreInfo();
    }
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }
  public setShipmentProviderFields(): void {
    this.storeShipmentProviderFields = [
      {
        key: 'key',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.shipmentProviders.shipmentProviderFields.key'
          ) as string,
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Key', v)
          ]
        },
      },
      {
        key: 'password',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.shipmentProviders.shipmentProviderFields.password'
          ) as string,
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Password', v)
          ]
        },
      },
      {
        key: 'accountNumber',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          type: 'number',
          label: this.$t(
            'stores.shipmentProviders.shipmentProviderFields.AccountNumber'
          ) as string,
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Account Number', v),
          ]
        },
      },
      {
        key: 'meterNumber',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.shipmentProviders.shipmentProviderFields.meterNumber'
          ) as string,
          type: 'number',
          counter: 50,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('Meter Number', v),
          ]
        },
      },
      {
        key: 'uri',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          label: this.$t(
            'stores.shipmentProviders.shipmentProviderFields.fedExUri'
          ) as string,
          counter: 200,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules:[
            v => this.required('FedEx Uri', v),
          ]
        },
      },
    ];
  }

  public validateShipmentProvider(): Vue & { validate: () => boolean } {
    return this.$refs.shipmentProviderForm as Vue & { validate: () => boolean };
  }

  public async saveStoreShipmentProvider(): Promise<void> {
    if(this.validateShipmentProvider().validate()){
      try {
        this.requestProgress = true;
        if (this.shipmentFedExModel) {
          this.shipmentProviderModel = {
            fedEx: this.shipmentFedExModel,
          };
          await storeService.saveShipmentProvider(
            this.storeId,
            this.shipmentProviderModel
          );
          this.showAlert(
            true,
            this.$t('stores.shipmentProviders.alertShipmentPrividerSaved')
          );
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                tenantId: this.tenantId.toString(),
                enterpriseId: this.enterpriseId.toString(),
                storeId: this.storeId.toString(),
                tab:'Shipment'
              },
            })
            .catch((ex) => {console.log(ex);});
        } else {
          this.showAlert(
            false,
            this.$t('stores.shipmentProviders.alertFillRequiredFields')
          );
        }
      } finally {
        this.requestProgress = false;
      }
    }
  }

  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storeShipmentProviderFields);
      const response = await storeService.getStore(this.storeId);
      this.storeViewModel = response;
      this.storeModel.id = this.storeViewModel.id;
      this.storeModel.storeJson = this.storeViewModel.storeJson;
      this.shipmentFedExModel = {
        key: this.storeViewModel.shipmentProviderJson
          ? this.storeViewModel.shipmentProviderJson.fedEx.key
          : '',
        password: this.storeViewModel.shipmentProviderJson
          ? this.storeViewModel.shipmentProviderJson.fedEx.password
          : '',
        accountNumber: this.storeViewModel.shipmentProviderJson
          ? this.storeViewModel.shipmentProviderJson.fedEx.accountNumber
          : '',
        meterNumber: this.storeViewModel.shipmentProviderJson
          ? this.storeViewModel.shipmentProviderJson.fedEx.meterNumber
          : '',
        uri: this.storeViewModel.shipmentProviderJson
          ? this.storeViewModel.shipmentProviderJson.fedEx.uri
          : '',
      };
    } finally {
      this.formlyHideSkeleton(this.storeShipmentProviderFields);
    }
  }
}
